import { useQuickActionsMenuContext } from 'modules/quickActionsMenu/contexts';
import { PAGE } from 'modules/quickActionsMenu/types';
import { getBadgeText, getPlaceholderText } from 'modules/quickActionsMenu/utils';
import { Search24 } from 'ui/icons';
import { CommandInput, PageNameBadge, SearchBar, SearchContainer } from './SearchInput.styled';

export const SearchInput = ({ page }: { page: PAGE }) => {
  const { searchTerm, setSearchTerm } = useQuickActionsMenuContext();

  return (
    <SearchBar data-test="search-bar">
      <Search24 data-test="search-icon" />
      <SearchContainer data-test="search-container">
        {page !== PAGE.HOME_PAGE && (
          <>
            <PageNameBadge data-test="page-name">{getBadgeText(page)}</PageNameBadge>
          </>
        )}
        <CommandInput
          data-test="search-input"
          value={searchTerm}
          autoFocus
          onValueChange={setSearchTerm}
          placeholder={getPlaceholderText(page)}
        />
      </SearchContainer>
    </SearchBar>
  );
};
